/** Service Desk cards on the dashboard and the billing overview (RPT-002, PLN-005, SD-S1-53). */
export const serviceCards = {
  dashboard: {
    title: "Service Desk",
    subtitle: "Where the team stands right now",
    open: "Open tickets",
    openHint: "New, open, pending and on hold",
    breaching: "Breaching soon",
    breachingHint: "Due within the hour or already late",
    csat: "CSAT, last 30 days",
    csatNone: "No ratings yet",
    csatHint_other: "{{count}} responses",
    csatHint_one: "{{count}} response",
    openTickets: "Open tickets",
    openReports: "Service reports",
    loadError: "We couldn't load the Service Desk figures.",
    retry: "Try again",
  },
  billing: {
    title: "Service Desk usage",
    subtitle: "Tickets, storage, connectors, catalogue, orders, equipment and staff AI",
    tickets: "Tickets this month",
    ticketsHint: "Fair use: nobody is ever refused a ticket.",
    storage: "Attachment storage",
    storageHint: "Photos, documents and signatures on tickets.",
    connectors: "Connectors",
    connectorsHint: "Systems your orders and catalogue connect to.",
    catalogue: "Catalogue items",
    catalogueHint: "Active products cached from your purchasing system.",
    orders: "Orders this month",
    ordersHint: "Orders your clients confirmed.",
    assets: "Equipment in service",
    assetsHint: "Registered units that are not retired.",
    fieldSeats: "Field seats",
    fieldSeatsHint: "Members whose only role is Field engineer.",
    staffAi: "Staff AI credits this month",
    staffAiHint: "Summaries, suggested replies and triage.",
    unlimited: "Unlimited",
    noLimit: "no limit",
    of: "/ {{value}}",
    mb: "{{value}} MB",
    gb: "{{value}} GB",
    readOnly: "Your plan no longer includes the Service Desk. It stays read-only until {{date}}.",
    readOnlyNoDate: "Your plan no longer includes the Service Desk, so it is read-only.",
    closed: "Your plan no longer includes the Service Desk.",
    reports: "Service reports",
    loadError: "We couldn't load the Service Desk usage.",
    retry: "Try again",
  },
} as const;
